export default "__VITE_ASSET__BAaWt4gC__"